import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Container,
    Form,
    Grid,
    Header,
    Icon,
    Item,
    List,
    Segment
} from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from "react-dates/constants";
import { DateRangePicker } from "react-dates";
import moment from "moment";

import "react-dates/lib/css/_datepicker.css";
import { authHeader } from "../../../../helpers/authHeader";
import axios from "axios";


class Reports extends Component {

    constructor(props) {
        super(props);

        this.state = {
            warehouse_id: null,
            start: moment()
                .startOf("month"),
            end: moment(),
            focusedInput: null,
            loading: false
        };
    }

    getOptions() {
        return [
            {
                key: 1,
                value: null,
                text: "Alle"
            },
            {
                key: 5,
                value: 5,
                text: "Embrach"
            },
            {
                key: 6,
                value: 6,
                text: "Oberriet"
            },
            {
                key: 7,
                value: 7,
                text: "Chur"
            },
            {
                key: 12,
                value: 12,
                text: "St.Gallen"
            }
        ];
    }

    onWarehouseSelect(value) {
        this.setState({ warehouse_id: value });
    }

    render() {
        const smallDevice = window.matchMedia("(max-width: 400px)").matches;
        const orientation = smallDevice ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION;
        return (
            <Container text style={{ padding: "1em 1em" }}>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='lightning' circular/>
                </Header>
                <Grid
                    textAlign='center'
                    style={{ height: "100%" }}
                    verticalAlign='middle'
                >
                    <Grid.Column width={14}>

                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                {this.props.translate("admin.reports.label")}
                            </Header>
                            <Segment stacked loading={this.state.loading}>

                                <Form.Select
                                    fluid
                                    label={this.props.translate("clock.warehouse.label")}
                                    options={this.getOptions()}
                                    value={this.state.warehouse_id}
                                    onChange={(e, { value }) => {
                                        this.onWarehouseSelect(value);
                                    }}
                                />

                                <Item>
                                    <Item.Content>
                                        <Item.Header as='a'>Zeitraum</Item.Header>
                                        <Item.Description>
                                            <DateRangePicker
                                                orientation={orientation}
                                                withPortal={smallDevice}
                                                startDate={this.state.start} // momentPropTypes.momentObj or null,
                                                startDateId="start_date_id" // PropTypes.string.isRequired,
                                                endDate={this.state.end} // momentPropTypes.momentObj or null,
                                                endDateId="end_date_id" // PropTypes.string.isRequired,
                                                isOutsideRange={(date) => date > moment()}
                                                onDatesChange={({ startDate, endDate }) => {
                                                    this.setState({
                                                        start: startDate,
                                                        end: endDate
                                                    });
                                                }} // PropTypes.func.isRequired,
                                                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                                block={true}
                                            />
                                        </Item.Description>
                                    </Item.Content>
                                </Item>


                                <List>
                                    <List.Item>
                                        <Button primary fluid size='big' onClick={() => {
                                            this.downloadReport("marge");
                                        }}>Margenbericht</Button>
                                    </List.Item>
                                    <List.Item>
                                        <Button primary fluid size='big' onClick={() => {
                                            this.downloadReport("inventory");
                                        }}>Lagerbericht</Button>
                                    </List.Item>
                                </List>


                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }

    downloadReport(name) {
        this.setState({ loading: true });

        const requestOptions = {
            headers: Object.assign(authHeader(), {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }),
            responseType: "blob"
        };

        return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/reporting/" + name, {
            warehouse_id: this.state.warehouse_id,
            start_date: moment(this.state.start)
                .format("YYYY-MM-DD"),
            end_date: moment(this.state.end)
                .format("YYYY-MM-DD")
        }, requestOptions)


            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", name + "_report.xlsx");
                document.body.appendChild(link);
                link.click();
                this.setState({ loading: false });

            }, (error) => {
                this.setState({ loading: false });
            });
    }

}


const mapStateToProps = state => {
    return {
        translate: getTranslate(state.localize),
    };
};

const mapDispatchToProps = (dispatch) => {
    return ({});
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Reports);



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/Reports/index.js